import React from 'react'
import { Stack } from '../../../components/DesignSystem'
import { RadioGroup } from '../../../components/DesignSystem'
import { GiftCardType } from '../types'
import { Control } from 'react-hook-form'

interface BuyGiftCardPromptProps {
	deviceHasInternet: boolean
	control: Control<any>
	name: string
}

export default function BuyGiftCardPrompt({
	deviceHasInternet,
	control,
	name,
}: BuyGiftCardPromptProps) {
	const options = [
		{
			value: GiftCardType.Personal,
			label: 'For myself',
			disabled: !deviceHasInternet,
		},
		{
			value: GiftCardType.Gift,
			label: 'For someone else',
			disabled: !deviceHasInternet,
		},
	]

	return (
		<Stack align={{ mobile: 'left', tablet: 'left', desktop: 'left' }}>
			<RadioGroup
				label="Looking to buy a gift card?"
				options={options}
				control={control}
				name={name}
				direction="horizontal"
				align={{ mobile: 'start', tablet: 'start', desktop: 'start' }}
			/>
		</Stack>
	)
}
